
const pad = {}
// 使用环境变量配置 API 地址（不包含路径）
// development/test 环境: 使用相对路径 /api.php（走代理或同域）
// production 环境: https://test.erp.duobaby.net
const apiHost = process.env.API_BASE_URL || 'https://test.erp.duobaby.net'
// pad.host 保留用于兼容性
pad.host = apiHost
// pad.baseUrl 是完整的 API 基础路径
// 开发环境和测试环境：使用相对路径走代理 /api.php（避免跨域）
// 生产环境：使用完整路径 https://test.erp.duobaby.net/api.php
const isDevelopment = process.env.NODE_ENV === 'development'
const isTest = process.env.NODE_ENV === 'test'
// 判断是否使用完整路径：
// 1. 生产环境：使用完整路径
// 2. 开发环境但 API_BASE_URL 以 http 开头：使用完整路径（用于本地运行正式环境）
// 3. 其他情况：使用相对路径（走代理）
const useFullPath = !isDevelopment || (apiHost && apiHost.startsWith('http'))
// 开发环境和测试环境使用相对路径，生产环境使用完整路径
pad.baseUrl = useFullPath ? (apiHost + '/api.php') : '/api.php'

console.log('apiHost', apiHost, 'pad', pad)
// baseRequestUrl 用于 axios baseURL 配置（开发环境和测试环境使用相对路径时为空字符串）
pad.baseRequestUrl = useFullPath ? apiHost : ''
pad.loginUrl = pad.baseUrl + '/Login/login'//登录
// pad.loginUrl = pad.baseUrl + '/Login/externalLogin'//外部登录
pad.checkLoginUrl = pad.baseUrl + '/Login/CheckLogin'//监听用户状态
pad.getUserInfoUrl = pad.baseUrl + '/Erp2Member/agentInfo' //获取用户信息

pad.getFormTypeList = pad.baseUrl + '/FormRecordNurs/getFormTypeList'//获取所用表格列表
pad.getAgentList = pad.baseUrl + '/FormRecordNurs/getAgentList'//获取查房/填写人列表
pad.getFormDataList = pad.baseUrl + '/FormRecordNurs/getFormDataList'//获取查房记录相关表格数据列表
pad.momEvaluationSheetUrl = pad.baseUrl + '/Form/mom_evaluation_sheet'//妈妈入住评估表
pad.setMomEvaluationSheetUrl = pad.baseUrl + '/Form/set_mom_evaluation_sheet'//提交妈妈入住评估表
pad.member_listUrl = pad.baseUrl + '/Member/member_list'//孕妇列表
pad.detial_memberUrl = pad.baseUrl + '/Member/detial_member'//孕妇详情
pad.babyListUrl = pad.baseUrl + '/Child/get_child_list'//获取宝宝列表
pad.roundFormListUrl = pad.baseUrl + '/Data/get_round_form_list'//获取所有查房表
pad.livingMemberTopUrl = pad.baseUrl + '/Member/living_member_top'
pad.getGroupListUrl = pad.baseUrl + '/Form/get_round_list'//获取查房表记录
pad.roundAllListUrl = pad.baseUrl + '/Form/round_all_list'//所有查房记录
pad.addRecordFormUrl = pad.baseUrl + '/Form/get_form_detail'//添加/编辑记录表单
pad.setOtherFormUrl = pad.baseUrl +'/Form/set_other_form'//其他表单答案上传
pad.setRoundRecordUrl = pad.baseUrl + '/Form/set_round_record'//查房记录答案上传
pad.detailOtherFormUrl = pad.baseUrl + '/Form/detail_other_form'//其他表单详情
pad.babyEvaluationSheetUrl = pad.baseUrl + '/Form/baby_evaluation_sheet'//宝宝入住评估
pad.setBabyEvaluationSheetUrl = pad.baseUrl + '/Form/set_bady_evaluation_sheet'//宝宝入住评估答案上传
pad.getBabeMedicationListUrl = pad.baseUrl + '/BabeService/getBabeMedicationList'//获取宝宝服药登记列表
pad.addBabeMedicationListUrl = pad.baseUrl + '/BabeService/addBabeMedication'//添加宝宝服药登记列表
pad.getBabeSignListUrl = pad.baseUrl + '/BabeService/getBabeSignList'//获得宝宝体质记录信息
pad.addBabeSignUrl = pad.baseUrl + '/BabeService/addBabeSign'//添加宝宝体质记录
pad.getBreastMilkRecoredUrl = pad.baseUrl + '/BabeService/getBreastMilkRecored'//获得母乳存放记录
pad.addBreastMilkUrl = pad.baseUrl +'/BabeService/storeBreastMilk'//添加母乳存放记录
pad.getBabeFeedRecoredUrl = pad.baseUrl +'/BabeService/getBabeFeedRecored'//获得宝宝喂养记录
pad.addBabeFeedRecoredUrl = pad.baseUrl +'/BabeService/addBabeFeedRecored'//添加宝宝喂养记录
pad.otherFormListUrl = pad.baseUrl +'/Form/other_form_list'//其他表单列表
pad.columnListUrl = pad.baseUrl +'/Form/column_list'//获取对应字段答案
pad.leaveMemberUrl = pad.baseUrl +'/Member/leave_member'//30天内离院的客户
pad.addBabyCareOperaDataUrl = pad.baseUrl +'/formRecord/addBabyCareOperaData'//婴儿护理操作记录表添加
pad.getBabyCareOperalistUrl = pad.baseUrl +'/formRecord/getBabyCareOperaList'//婴儿护理操作记录表查询list数据
pad.getBabyCareOperaFindUrl = pad.baseUrl +'/formRecord/getBabyCareOperaFind'//婴儿护理操作记录表详情数据
pad.updateBabyCareOperaDataUrl = pad.baseUrl +'/formRecord/updateBabyCareOperaData'//婴儿护理操作记录表数据更新
pad.addBabyNursOneDataUrl = pad.baseUrl +'/FormRecordNurs/addBabyNursOneData'//婴儿护理记录单（1）添加数据
pad.getBabyNursOneDataListUrl = pad.baseUrl +'/FormRecordNurs/getBabyNursOneDataList'//婴儿护理记录单（1）查询list数据
pad.getBabyNursOneFindUrl = pad.baseUrl +'/FormRecordNurs/getBabyNursOneFind'//婴儿护理记录单（1）详情数据
pad.updateBabyNursOneDataUrl = pad.baseUrl +'/FormRecordNurs/updateBabyNursOneData'//婴儿护理记录单（1）更新
pad.addBabyNursTwoDataUrl = pad.baseUrl +'/FormRecordNurs/addBabyNursTwoData'//婴儿护理记录单（2）添加数据
pad.getBabyNursTwoDataListUrl = pad.baseUrl +'/FormRecordNurs/getBabyNursTwoList'//婴儿护理记录单（2）查询list数据
pad.getBabyNursTwoFindUrl = pad.baseUrl +'/FormRecordNurs/getBabyNursTwoFind'//婴儿护理记录单（2）详情数据
pad.updateBabyNursTwoDataUrl = pad.baseUrl +'/FormRecordNurs/updateBabyNursTwoDate'//婴儿护理记录单（2）更新
pad.addBabyFeedingRecordDataUrl = pad.baseUrl +'/FormRecord/addBabyFeedingRecordData'//婴儿喂养记录单添加数据添加数据
pad.getBabyFeedingRecordListUrl = pad.baseUrl +'/FormRecord/getBabyFeedingRecordList'//婴儿喂养记录单添加数据查询list数据
pad.getBabyFeedingRecordFindUrl = pad.baseUrl +'/FormRecord/getBabyFeedingRecordFind'//婴儿喂养记录单添加数据详情数据
pad.updateBabyFeedingRecordDataUrl = pad.baseUrl +'/FormRecord/updateBabyFeedingRecordData'//婴儿喂养记录单添加数据更新
pad.addMaternalEverydayPhysiologyUrl = pad.baseUrl +'/formRecord/addMaternalEverydayPhysiology'//产妇每日生理护理记录添加数据
pad.getMaternalEverydayPhysiologyListUrl = pad.baseUrl +'/formRecord/getMaternalEverydayPhysiologyList'//产妇每日生理护理记录查询list数据
pad.getMaternalEverydayPhysiologyFindUrl = pad.baseUrl +'/formRecord/getMaternalEverydayPhysiologyFind'//产妇每日生理护理记录详情数据
pad.updateMaternalEverydayPhysiologyUrl = pad.baseUrl +'/formRecord/updateMaternalEverydayPhysiology'//产妇每日生理护理记录数据更新
pad.addMaternalMealRecordsDataUrl = pad.baseUrl +'/FormRecord/addMaternalMealRecordsData'//产妇膳食记录添加数据
pad.getMaternalMealRecordsListUrl = pad.baseUrl +'/FormRecord/getMaternalMealRecordsList'//产妇膳食记录查询list数据
pad.getMaternalMealRecordsFindUrl = pad.baseUrl +'/FormRecord/getMaternalMealRecordsFind'//产妇膳食记录单详情数据
pad.updateMaternalMealRecordsDataUrl = pad.baseUrl +'/FormRecord/updateMaternalMealRecordsData'//产妇膳食记录更新
pad.addMaterRehNursEvalDataUrl = pad.baseUrl +'/FormRecord/addMaterRehNursEvalData'//产妇康复护理评估记录单添加数据
pad.getMaterRehNursEvalListUrl = pad.baseUrl +'/FormRecord/getMaterRehNursEvalList'//产妇康复护理评估记录单查询list数据
pad.getMaterRehNursEvalFindUrl = pad.baseUrl +'/FormRecord/getMaterRehNursEvalFind'//产妇康复护理评估记录单详情数据
pad.updateMaterRehNursEvalDataUrl = pad.baseUrl +'/FormRecord/updateMaterRehNursEvalData'//产妇康复护理评估记录单记录更新
pad.getFormStatusUrl = pad.baseUrl +'/FormRecord/getFormStatus'//获取固定表单数据状态
pad.addNewBornCheckAssessDataUrl = pad.baseUrl +'/formRecord/addNewBornCheckAssessData'//新生儿入住评估单添加
pad.getNewBornCheckAssessFindUrl = pad.baseUrl + '/formRecord/getNewBornCheckAssessFind'//新生儿入住评估单详情数据
pad.updateNewBornCheckAssessDataUrl = pad.baseUrl + '/formRecord/updateNewBornCheckAssessData'//新生儿入住评估单更新数据
pad.addNewbornFullmoonAssessDataUrl = pad.baseUrl +'/FormRecord/addNewbornFullmoonAssessData'//新生儿满月评估单添加数据
pad.getNewbornFullmoonAssessFindUrl = pad.baseUrl + '/FormRecord/getNewbornFullmoonAssessFind'//新生儿满月评估单详情数据
pad.updateNewNewbornFullmoonAssessDataUrl = pad.baseUrl + '/FormRecord/updateNewNewbornFullmoonAssessData'//新生儿满月评估更新数据
pad.addMaterCheckAssessDataUrl = pad.baseUrl + '/formRecord/addMaterCheckAssessData'//母亲入住评估单添加数据
pad.getMaterCheckAssessFindUrl = pad.baseUrl + '/formRecord/getMaterCheckAssessFind'//母亲入住评估单详情数据
pad.updateMaterCheckAssessDataUrl = pad.baseUrl + '/formRecord/updateMaterCheckAssessData'//母亲入住评估单更新数据
pad.updateMaternalLeaveProveRecordUrl = pad.baseUrl + '/formRecord/updateMaternalLeaveProveRecord'//出院证明编辑/填写
pad.MaternalLeaveProveRecordUrl = pad.baseUrl + '/formRecord/MaternalLeaveProveRecord'//出院证明详情
pad.updateMaternalHospitalChecklistRecordUrl = pad.baseUrl + '/formRecord/updateMaternalHospitalChecklistRecord'//医院就诊单编辑
pad.MaternalHospitalChecklistRecordUrl = pad.baseUrl + '/formRecord/MaternalHospitalChecklistRecord'//医院就诊单详情
pad.updateBabyFootRecordUrl = pad.baseUrl + '/formRecord/updateBabyFootRecord'//宝宝足印编辑
pad.getBabyFootRecordUrl = pad.baseUrl + '/formRecord/getBabyFootRecord'//宝宝足印详情

pad.matarnalHeathRecordUrl = pad.baseUrl + '//formRecord/MatarnalHeathRecord'//（产妇）健康咨询记录表列表
pad.addMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/addMatarnalHeathRecord'//（产妇）健康咨询记录表列表添加
pad.updateMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/updateMatarnalHeathRecord'//（产妇）健康咨询记录表列表编辑
pad.getMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/getMatarnalHeathRecord'//（产妇）健康咨询记录表列表详情

pad.BabyHeathRecordUrl = pad.baseUrl + '//formRecord/BabyHeathRecord'//（新生儿）健康咨询记录表列表列表
pad.addBabyHeathRecordUrl = pad.baseUrl + '/formRecord/addBabyHeathRecord'//（新生儿）健康咨询记录表列表添加
pad.updateBabyHeathRecordUrl = pad.baseUrl + '/formRecord/updateBabyHeathRecord'//（新生儿）健康咨询记录表列表编辑
pad.getBabyHeathRecordUrl = pad.baseUrl + '/formRecord/getBabyHeathRecord'//（新生儿）健康咨询记录表列表详情

pad.MatarnalSpecialNursingRecordUrl = pad.baseUrl + '//formRecord/MatarnalSpecialNursingRecord'//产妇特殊护理记录列表列表
pad.addMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/addMatarnalSpecialNursingRecord'//产妇特殊护理记录列表添加
pad.updateMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/updateMatarnalSpecialNursingRecord'//产妇特殊护理记录列表编辑
pad.getMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/getMatarnalSpecialNursingRecord'//产妇特殊护理记录列表详情

pad.babySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/babySpecialNursingRecord'//婴儿特殊护理记录列表列表
pad.addBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/addBabySpecialNursingRecord'//婴儿特殊护理记录列表添加
pad.updateBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/updateBabySpecialNursingRecord'//婴儿特殊护理记录列表编辑
pad.getBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/getBabySpecialNursingRecord'//婴儿特殊护理记录列表详情
pad.getCheckInfoUrl = pad.baseUrl + '/Form/get_check_info'//获取查房人列表

pad.feedDrugEntrustUrl = pad.baseUrl + '/FormRecord/feedDrugEntrust'//喂药委托书列表
pad.updateFeedDrugEntrustUrl = pad.baseUrl + '/FormRecord/updateFeedDrugEntrust'//更新喂药委托书列表
pad.addFeedDrugEntrustUrl = pad.baseUrl + '/FormRecord/addFeedDrugEntrust'//添加喂药委托书列表
pad.detailFeedDrugEntrustDetailUrl = pad.baseUrl + '/FormRecord/feedDrugEntrustDetail'//详情喂药委托书列表

pad.confinementSenseListUrl = pad.baseUrl + '/FormRecord/confinement_sense_list'//月子基本护理常识
pad.updateConfinementSenseUrl = pad.baseUrl + '/FormRecord/update_confinement_sense'//更新月子基本护理常识
pad.addConfinementSenseUrl = pad.baseUrl + '/FormRecord/add_confinement_sense'//添加月子基本护理常识
pad.confinementSenseDetailUrl = pad.baseUrl + '/FormRecord/confinement_sense_detail'//详情月子基本护理常识


pad.getBatchMatarnalHeathRecordList =  pad.baseUrl + '/formRecord/getBatchMatarnalHeathRecordList' //健康咨询批处理 宝妈列表
pad.getBatchBabyHeathRecordList =  pad.baseUrl + '/formRecord/getBatchBabyHeathRecordList' //健康咨询批处理 宝宝列表

pad.batchMatarnalHeathRecord =  pad.baseUrl + '/formRecord/BatchMatarnalHeathRecord' //《新生儿健康咨询记录表》
pad.batchBabyHeathRecord =  pad.baseUrl + '/formRecord/BatchBabyHeathRecord' //《产妇健康咨询记录表》
pad.batchHeathRecord = pad.baseUrl + '/formRecord/BatchHeathRecord' //健康咨询批处理 处理记录列表
pad.batchAddBabyCareOpera = pad.baseUrl + '/formRecordNurs/batchAddBabyCareOpera' //婴儿护理操作记录表 处理记录列表

pad.batchAddBabyNursOne = pad.baseUrl + '/formRecordNurs/batchAddBabyNursOne' //批量保存婴儿护理记录单（1）
pad.batchAddBabyNursTwo = pad.baseUrl + '/formRecordNurs/batchAddBabyNursTwo' //批量保存婴儿护理记录单（2)
pad.batchAddMaternalEverydayPhysiology = pad.baseUrl + '/formRecord/batchAddMaternalEverydayPhysiology' //产妇每日生理护理记录批处理
pad.batchAddMaterRehNursEvalData = pad.baseUrl + '/formRecord/batchAddMaterRehNursEvalData' //产妇康复护理评估记录批处理


pad.batchHeathRecordDetail = pad.baseUrl + '/formRecord/BatchHeathRecordDetail' //健康咨询批处理 记录详情
//护理特情上报
pad.getSpecialReport = pad.baseUrl + '/Member/specialReport' //特情上报
pad.getDepartmentList = pad.baseUrl + '/Member/getDepartmentList' //特情上报
pad.specialReportAdd = pad.baseUrl + '/Member/specialReportAdd' //特情上报
pad.getPositionList = pad.baseUrl + '/Member/getPositionList' //获取上报职位
pad.getMaternalAgentList = pad.baseUrl + '/Member/getAgentList' //上报人

//客房部特情上报
pad.getSpecialReportRoom = pad.baseUrl + '/Member/specialReportRoom' //特情上报
pad.specialReportAddRoom = pad.baseUrl + '/Member/specialReportAddRoom' //特情上报
//餐饮部特情上报
pad.getSpecialReportMeal = pad.baseUrl + '/Member/specialReportMeal' //特情上报
pad.specialReportAddMeal = pad.baseUrl + '/Member/specialReportAddMeal' //特情上报

module.exports = pad





// WEBPACK FOOTER //
// ./src/service/api/api-const.js